function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_37234_39794)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.9375 18.5034H12.5627V20.1889C12.5627 20.803 12.0597 21.306 11.4456 21.306H9.05461C8.44053 21.306 7.9375 20.803 7.9375 20.1889V18.5034Z",
  className: "color-stroke",
  strokeWidth: 1.11,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.14648 21.3057H11.3611V22.1288C11.3611 22.5796 10.9953 22.9389 10.551 22.9389H9.96308C9.51232 22.9389 9.15302 22.573 9.15302 22.1288V21.3057H9.14648Z",
  className: "color-stroke",
  strokeWidth: 1.11,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.93761 18.5033C7.93761 15.1585 5.24609 13.5971 5.24609 10.8468C5.24609 8.09652 7.48031 5.8623 10.2306 5.8623C12.9809 5.8623 15.2151 8.09652 15.2151 10.8468C15.2151 13.5971 12.5694 14.969 12.5694 18.5033",
  className: "color-stroke",
  strokeWidth: 1.11,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.2305 1.06055V3.39929",
  className: "color-stroke",
  strokeWidth: 1.11,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.70397 10.8794H0.365234",
  className: "color-stroke",
  strokeWidth: 1.11,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.1285 10.8794H17.7832",
  className: "color-stroke",
  strokeWidth: 1.11,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.91256 5.54849L3.25977 3.88916",
  className: "color-stroke",
  strokeWidth: 1.11,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.2335 17.8629L15.5742 16.2036",
  className: "color-stroke",
  strokeWidth: 1.11,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.91256 16.2036L3.25977 17.8629",
  className: "color-stroke",
  strokeWidth: 1.11,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.2335 3.88916L15.5742 5.54849",
  className: "color-stroke",
  strokeWidth: 1.11,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_37234_39794"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20.4868,
  height: 22.61,
  fill: "white",
  transform: "translate(0 0.694824)"
})));
function SvgIcnBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "color-fill",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnBulb);
export default __webpack_public_path__ + "static/media/icn-bulb.a96286e186113391c5075ac76bc81792.svg";
export { ForwardRef as ReactComponent };